<template>
  <div>
    <transition name="backdrop" appear>
      <div v-if="showModal" class="backdrop fixed bg-gray-600 bg-opacity-50 top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto show z-10" :class="{'lg:hidden': !modalBackdrop}" />
    </transition>
    <transition name="modal" appear>
      <div v-if="showModal" :id="id" class="modal fade fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto show z-[11]" :aria-hidden="!showModal" :aria-modal="showModal" role="dialog">
        <div v-bind="$attrs" class="modal-dialog relative w-auto pointer-events-none" :class="[size, {'modal-dialog-scrollable': modalScrollable, 'lg:ml-8': modalAlign == 'left'}]">
          <div class="shadow_box modal-content border-none relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div v-if="hasSlots('header')" class="modal-header flex flex-shrink-0 items-center justify-between p-4 border-b border-gray-200 rounded-t-md">
              <slot name="header" />
            </div>
            <div v-if="hasSlots('body')" ref="modalEditBody" class="modal-body relative p-4 mt-4 mb-4 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200">
              <slot name="body" />
            </div>
            <div v-if="hasSlots('footer')" class="modal-footer flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
              <slot name="footer" />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { v4 as uuid } from 'uuid'
import { ref } from 'vue'
export default {
  props: {
    id: {
      type: String,
      default() {
        return `modal-${uuid()}`
      },
    },
    showModal: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
    modalScrollable: {
      type: Boolean,
      default: false,
    },
    modalAlign: {
      type: String,
      default: 'center',
    },
    modalBackdrop: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const showModal = ref(props.showModal)

    return {
      showModal,
    }
  },
  watch: {
    showModal(val) {
      if(!val) {
        this.$refs.modalEditBody.scrollTop = 0
        document.body.classList.remove('modal-open')
      } else {
        document.body.classList.add('modal-open')
      }
    },
  },
  methods: {
    hasSlots(slotName) {
      return this.$slots ? !!this.$slots[ slotName ] : false
    },
    open() {
      this.showModal = true
    },
    close() {
      this.showModal = false
    },
  },
}
</script>
<style>
.backdrop-enter-active,
.backdrop-leave-active {
  transition: opacity .4s linear;
}

.backdrop-enter,
.backdrop-leave-to {
  opacity: 0;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity .2s linear;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
